"use strict";

var Sentry = require("@sentry/browser");
var config = require("app/util/config/config");

Sentry.init({
  dsn: config.sentry.dsn,
  environment: config.env
});

if (window.loggedUserId) {
  Sentry.setUser({
    id: window.loggedUserId,
    username: window.loggedUserName,
    email: window.loggedUserEmail
  });
}

module.exports = Sentry;



// WEBPACK FOOTER //
// ./app/util/browser/sentry.js